import { VariableValue, TableValue } from 'product_modules/api/Types';
import { CorrespondenceChecker } from 'product_modules/utils/valueVisualTypeCorrespondenceCheckers/Types';

const isCorrespondsTable: CorrespondenceChecker<TableValue> = (value: VariableValue): value is TableValue => {
  return Array.isArray(value) && value.every((row) => typeof row === 'object');
};

export default isCorrespondsTable;
